import axios from 'axios'

let getUrlRoot = function(root) {
  if (root == '-') {
    // Get the current route's root
    return '.'
  }
  else {
    return root
  }
} 

export default () => {
  // console.log('Dev  api = ' + getUrlRoot(process.env.VUE_APP_RESRE_API_URL_ROOT))
  // console.log('Live api = ' + getUrlRoot('-'))
  return axios.create({
    baseURL: getUrlRoot(process.env.VUE_APP_RESRE_API_URL_ROOT)
  })
}
